import React from "react";
import { useAppSelector } from "../../../redux/store";
import { useTranslation } from "react-i18next";

const HolidayDestinations = () => {
  const { t } = useTranslation();
  const booking = useAppSelector((state) => state.booking);
  const destinations = booking.bookingDetails.holidayDestinations;

  if (destinations.length == 0) return null;

  return (
    <>
      <p>
        <strong>{t("bookingDetails.overview.destinations")} : </strong>
      </p>
      {destinations && destinations.length > 0 && (
        <>
          {destinations.map((item, i: any) => (
            <p key={i} className="m-0">
              {item}
            </p>
          ))}
        </>
      )}
    </>
  );
};

export default HolidayDestinations;
